<div class="desktop-container" [ngClass]="{'last': isLast}">
    <div>
        <span class="intro">
            @if (task ; as task) {
                <div>
                    <h3 class="p-0 m-0">{{ title }}</h3>
                    <div class="flex items-center gap-2">
                        <p> Due Date <b>{{ dueDateLabel }}.</b></p> <p> Status: <b>{{ status }}</b></p>
                        @if (totalAssociations > 0) {
                            <p >Associations: <b>{{ totalAssociations }}</b></p>
                        }
                    </div>
                </div>
                    
            }
        </span>
 
    </div>
    <div class="form-type type-task">
        Task
    </div>
    <app-flight-card-cta class="w-full" [flight]="task" [type]="'task'" [isEditable]="showEdit" [canBeArchived]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
  <app-combined-task-card-mobile
    [data]="task"
    [type]="'task'"
    [showEdit]="showEdit"
  ></app-combined-task-card-mobile>
</div>

